import { useRef, useImperativeHandle, forwardRef } from 'react'
import PropTypes from 'prop-types'

export const ButtonCargaNomina = forwardRef(({ onFileSelected }, ref) => {
  const fileInputRef = useRef(null)

  const openFilePicker = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = (event) => {
    const file = event.target.files?.[0]
    if (file) {
      onFileSelected(file)
      event.target.value = ''
    }
  }

  useImperativeHandle(ref, () => ({
    openFilePicker,
  }))

  return (
    <>
      <input type="file" ref={fileInputRef} className="hidden" onChange={handleFileChange} />
    </>
  )
})

ButtonCargaNomina.displayName = 'ButtonCargaNomina'

ButtonCargaNomina.propTypes = {
  onFileSelected: PropTypes.func.isRequired,
}

export default ButtonCargaNomina
